import { useAsyncCallback } from 'apps/sigma2-ui/src/lib/hooks/useAsyncCallback';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';
import { GenerateShareLinkRequest } from 'libs/end-to-end/src/links';
import { GenerateShareLinkResult } from 'libs/end-to-end/src/links';
import { PayBenchmarkingRequest } from 'libs/end-to-end/src/custom-viz/PayBenchmarkingTypes';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { PayBenchmarkingState } from 'apps/sigma2-ui/src/pay-benchmarking/components/types';

export const usePayBenchmarkingGenerateShareLink = ({
  currentState,
  userAuthenticatedApiCall,
  request,
}: {
  currentState: PayBenchmarkingState;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
  request: PayBenchmarkingRequest | null;
}) => {
  return useAsyncCallback(
    async (isAlive, onComplete: (shareLink: string) => void) => {
      uiAppLogger.info('starting_share');
      if (!isAlive() || !request) {
        return;
      }

      if (currentState.state !== 'success') {
        uiAppLogger.info('output_type', currentState.state);
        return;
      }

      uiAppLogger.info('successful output');

      const shareLinkRequestBody: GenerateShareLinkRequest = {
        baseUrl: window.location.origin,
        request,
      };

      uiAppLogger.info(shareLinkRequestBody);

      const generateShareLinkResult = await userAuthenticatedApiCall({
        url: `${getApiBaseUrl()}/share/generate`,
        requestOptions: {
          method: 'POST',
          body: JSON.stringify(shareLinkRequestBody),
        },
        responseSchema: GenerateShareLinkResult,
      });
      if (
        !generateShareLinkResult ||
        generateShareLinkResult.resultType === 'err'
      ) {
        return;
      }

      const link = generateShareLinkResult.value.shareLink;
      onComplete(link);
    },
    [currentState.state, request, userAuthenticatedApiCall],
  );
};
